// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';
import React from 'react';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { changeCaseFirstLetter } from '../utils/NewSearchBar.util';
import style from '../styles/IAmLookingFor.style';

export const HighLightSearch = ({ searchInput, inputTextParam }) => {
  const text = searchInput && searchInput.current ? searchInput.current.value : '';
  let { inputText } = inputTextParam;
  inputText = inputText.toLowerCase();
  const index = inputText.indexOf(text.toLowerCase());
  inputText = changeCaseFirstLetter(inputText);
  if (index >= 0 && inputText) {
    return (
      <div className="looking-for-text-wrapper">
        {`${inputText.substring(0, index)}`}
        <span className="highlight-search-result">
          {`${inputText.substring(index, index + text.length)}`}
        </span>
        {`${inputText.substring(index + text.length)}`}
      </div>
    );
  }
  return <div className="looking-for-text-wrapper">{`${inputText}`}</div>;
};

const IAmLookingFor = (props) => {
  const { className, searchResultData, searchInput, isSuggestionFound, redirectToSuggestedUrl } =
    props;

  const renderAutoSuggestionList = () => {
    const { heading, suggestionList } = searchResultData;
    if (isSuggestionFound) {
      return (
        <>
          <div className="iam-looking-for-header">{`${heading}`}</div>
          <div className="match-link-box-body">
            <ul>
              {suggestionList.map(({ id, text, itemUrl, toPath }) => {
                return (
                  <BodyCopy
                    component="li"
                    lineHeight="unset"
                    key={id}
                    className="suggestion-label-wrapper"
                    tabIndex="0"
                    onKeyPress={(e) => {
                      e.preventDefault();
                      redirectToSuggestedUrl(`${text}`, itemUrl);
                    }}
                  >
                    <Anchor
                      noLink
                      className="suggestion-label"
                      tabIndex="-1"
                      to={toPath}
                      onClick={(e) => {
                        e.preventDefault();
                        redirectToSuggestedUrl(`${text}`, itemUrl);
                      }}
                    >
                      {text && (
                        <HighLightSearch
                          className="suggestion-label-highlight"
                          tabIndex="-1"
                          inputTextParam={{ inputText: text }}
                          searchInput={searchInput}
                        />
                      )}
                    </Anchor>
                  </BodyCopy>
                );
              })}
            </ul>
          </div>
        </>
      );
    }
    return null;
  };
  return <div className={`${className} i-am-looking-for`}>{renderAutoSuggestionList()}</div>;
};

const SearchInputPropTypes = PropTypes.shape({
  current: PropTypes.shape({
    value: PropTypes.string,
  }),
});

HighLightSearch.propTypes = {
  searchInput: SearchInputPropTypes,
  inputTextParam: PropTypes.shape({
    inputText: PropTypes.string,
  }).isRequired,
};
HighLightSearch.defaultProps = {
  searchInput: {},
};

IAmLookingFor.propTypes = {
  className: PropTypes.string.isRequired,
  isSuggestionFound: PropTypes.bool,
  searchResultData: PropTypes.shape({
    heading: PropTypes.string,
    suggestionList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        text: PropTypes.string,
        itemUrl: PropTypes.string,
        toPath: PropTypes.string,
      })
    ),
  }).isRequired,
  searchInput: SearchInputPropTypes,
  redirectToSuggestedUrl: PropTypes.func.isRequired,
};

IAmLookingFor.defaultProps = {
  isSuggestionFound: false,
  searchInput: null,
};
export { IAmLookingFor as IAmLookingForView };
export default withStyles(IAmLookingFor, style);
